import React from 'react';
import { FormattedMessage } from 'react-intl';
// eslint-disable-next-line import/no-cycle
import { IPermissionsArray } from './interfaces/permissions';
import messages from './messages/messages';
import commonMessages from 'common/messages/messages';
import {
  PermissionLevels,
  PoliciesPermissionSetItems as Permission,
} from 'common/constants/permissions';

export enum PermissionGroupsClubLevel {
  FINANCIAL = 'FINANCIAL',
  POINT_OF_SALE_POS = 'POINT_OF_SALE_POS',
  COLLECTIONS = 'COLLECTIONS',
}

export enum PermissionGroupsCorporateOrClubLevel {
  // could be on corporate and clubs levels
  SCHEDULING = 'SCHEDULING',
  CRM = 'CRM',
  PT_CRM = 'PT_CRM',
  POS_CONTENT = 'POS_CONTENT',
  MEMBER_MANAGEMENT = 'MEMBER_MANAGEMENT',
  EMPLOYEE_MANAGEMENT = 'EMPLOYEE_MANAGEMENT',
  TIME_CLOCK = 'TIME_CLOCK',
  REPORTING = 'REPORTING',
  SALES_MANAGEMENT = 'SALES_MANAGEMENT',
  CLIENT_MANAGEMENT = 'CLIENT_MANAGEMENT',
  SPAMBI = 'SPAMBI',
}

export enum PermissionGroupsCorporateLevel {
  CORPORATE_LEVEL = 'CORPORATE_LEVEL',
  SERVICE_MANAGEMENT = 'SERVICE_MANAGEMENT',
  DICTIONARIES = 'DICTIONARIES',
  PERMISSIONS = 'PERMISSIONS',
  CORPORATE_MANAGEMENT = 'CORPORATE_MANAGEMENT',
  COMMUNICATION = 'COMMUNICATION',
}

export enum PermissionGroupsPeakLevel {
  PEAK_LEVEL = 'PEAK_LEVEL',
}

export const permissionLevelsArray = {
  [PermissionLevels.PEAK]: PermissionGroupsPeakLevel,
  [PermissionLevels.CLIENT]: {
    ...PermissionGroupsClubLevel,
    ...PermissionGroupsCorporateOrClubLevel,
  },
  [PermissionLevels.CORPORATE]: {
    ...PermissionGroupsCorporateLevel,
    ...PermissionGroupsCorporateOrClubLevel,
  },
};

export const PermissionsGroupsLabels = {
  // club level
  [PermissionGroupsClubLevel.FINANCIAL]: <FormattedMessage {...messages.financial} />,
  [PermissionGroupsClubLevel.POINT_OF_SALE_POS]: <FormattedMessage {...messages.pos} />,
  [PermissionGroupsClubLevel.COLLECTIONS]: <FormattedMessage {...messages.collections} />,
  // corporate or club level
  [PermissionGroupsCorporateOrClubLevel.SCHEDULING]: <FormattedMessage {...messages.scheduling} />,
  [PermissionGroupsCorporateOrClubLevel.CRM]: <FormattedMessage {...messages.crm} />,
  [PermissionGroupsCorporateOrClubLevel.PT_CRM]: <FormattedMessage {...commonMessages.ptcrm} />,
  [PermissionGroupsCorporateOrClubLevel.POS_CONTENT]: (
    <FormattedMessage {...commonMessages.posContent} />
  ),
  [PermissionGroupsCorporateOrClubLevel.MEMBER_MANAGEMENT]: (
    <FormattedMessage {...messages.memberManagement} />
  ),
  [PermissionGroupsCorporateOrClubLevel.EMPLOYEE_MANAGEMENT]: (
    <FormattedMessage {...messages.employeeManagement} />
  ),
  [PermissionGroupsCorporateOrClubLevel.TIME_CLOCK]: (
    <FormattedMessage {...commonMessages.timeclock} />
  ),
  [PermissionGroupsCorporateOrClubLevel.REPORTING]: <FormattedMessage {...messages.reporting} />,
  [PermissionGroupsCorporateOrClubLevel.SALES_MANAGEMENT]: (
    <FormattedMessage {...messages.salesManagement} />
  ),
  [PermissionGroupsCorporateOrClubLevel.CLIENT_MANAGEMENT]: (
    <FormattedMessage {...messages.corporateClientManagement} />
  ),
  // corporate level
  [PermissionGroupsCorporateLevel.CORPORATE_LEVEL]: (
    <FormattedMessage {...commonMessages.corporateTitle} />
  ),
  [PermissionGroupsCorporateLevel.PERMISSIONS]: (
    <FormattedMessage {...commonMessages.permissions} />
  ),
  [PermissionGroupsCorporateLevel.CORPORATE_MANAGEMENT]: (
    <FormattedMessage {...messages.corporateManagement} />
  ),
  [PermissionGroupsCorporateLevel.SERVICE_MANAGEMENT]: (
    <FormattedMessage {...messages.corporateServiceManagement} />
  ),
  [PermissionGroupsCorporateLevel.DICTIONARIES]: (
    <FormattedMessage {...commonMessages.dictionaries} />
  ),
  [PermissionGroupsCorporateLevel.COMMUNICATION]: <FormattedMessage {...messages.communication} />,
  // pe level
  [PermissionGroupsPeakLevel.PEAK_LEVEL]: <FormattedMessage {...commonMessages.peakTitle} />,
  [PermissionGroupsCorporateOrClubLevel.SPAMBI]: <FormattedMessage {...messages.spambi} />,
};

export const PermissionsArrayPeakLevel: IPermissionsArray<PermissionGroupsPeakLevel> = {
  [PermissionGroupsPeakLevel.PEAK_LEVEL]: [
    {
      title: PermissionsGroupsLabels[PermissionGroupsPeakLevel.PEAK_LEVEL],
      key: PermissionGroupsPeakLevel.PEAK_LEVEL,
      children: [
        {
          title: <FormattedMessage {...messages.peakSuperUser} />,
          key: Permission.PEAK_SU,
        },
        {
          title: <FormattedMessage {...messages.peakHelpInformationView} />,
          key: Permission.PEAK_HELP_INFORMATION_VIEW,
        },
        {
          title: <FormattedMessage {...messages.peakHelpInformationCreate} />,
          key: Permission.PEAK_HELP_INFORMATION_CREATE,
        },
        {
          title: <FormattedMessage {...messages.peakHelpInformationEdit} />,
          key: Permission.PEAK_HELP_INFORMATION_EDIT,
        },
        {
          title: <FormattedMessage {...messages.peakHelpInformationChangeStatus} />,
          key: Permission.PEAK_HELP_INFORMATION_CHANGE_STATUS,
        },
        {
          title: <FormattedMessage {...messages.peakEmployeeView} />,
          key: Permission.PEAK_EMPLOYEE_VIEW,
        },
        {
          title: <FormattedMessage {...messages.peakEmployeeCreate} />,
          key: Permission.PEAK_EMPLOYEE_CREATE,
        },
        {
          title: <FormattedMessage {...messages.peakEmployeeEdit} />,
          key: Permission.PEAK_EMPLOYEE_EDIT,
        },
        {
          title: <FormattedMessage {...messages.peakEmployeeChangeStatus} />,
          key: Permission.PEAK_EMPLOYEE_CHANGE_STATUS,
        },
        {
          title: <FormattedMessage {...messages.peakOrganizationCreate} />,
          key: Permission.PEAK_ORGANIZATION_CREATE,
        },
        {
          title: <FormattedMessage {...messages.peakOrganizationView} />,
          key: Permission.PEAK_ORGANIZATION_VIEW_LIST,
        },
        {
          title: <FormattedMessage {...messages.peakOrganizationChangeStatus} />,
          key: Permission.PEAK_ORGANIZATION_CHANGE_STATUS,
        },
        {
          title: <FormattedMessage {...messages.peakSecurityRoleView} />,
          key: Permission.PEAK_SECURITY_ROLE_VIEW,
        },
        {
          title: <FormattedMessage {...messages.peakSecurityRoleCreate} />,
          key: Permission.PEAK_SECURITY_ROLE_CREATE,
        },
        {
          title: <FormattedMessage {...messages.peakSecurityRoleEdit} />,
          key: Permission.PEAK_SECURITY_ROLE_EDIT,
        },
        {
          title: <FormattedMessage {...messages.peakSecurityRoleChangeStatus} />,
          key: Permission.PEAK_SECURITY_ROLE_CHANGE_STATUS,
        },
        {
          title: <FormattedMessage {...messages.peakSecurityPolicyView} />,
          key: Permission.PEAK_SECURITY_POLICY_VIEW,
        },
        {
          title: <FormattedMessage {...messages.peakSecurityPolicyCreate} />,
          key: Permission.PEAK_SECURITY_POLICY_CREATE,
        },
        {
          title: <FormattedMessage {...messages.peakSecurityPolicyEdit} />,
          key: Permission.PEAK_SECURITY_POLICY_EDIT,
        },
        {
          title: <FormattedMessage {...messages.peakSecurityPolicyChangeStatus} />,
          key: Permission.PEAK_SECURITY_POLICY_CHANGE_STATUS,
        },
        {
          title: <FormattedMessage {...messages.peakOrganizationTransferOwnership} />,
          key: Permission.PEAK_ORGANIZATION_TRANSFER_OWNERSHIP,
        },
        {
          title: <FormattedMessage {...messages.peakOrganizationGeneralInfoView} />,
          key: Permission.PEAK_ORGANIZATION_GENERAL_INFO_VIEW,
        },
        {
          title: <FormattedMessage {...messages.peakOrganizationGeneralInfoEdit} />,
          key: Permission.PEAK_ORGANIZATION_GENERAL_INFO_EDIT,
        },
        {
          title: <FormattedMessage {...messages.peakOrganizationBankInfoView} />,
          key: Permission.PEAK_ORGANIZATION_BANK_INFO_VIEW,
        },
        {
          title: <FormattedMessage {...messages.peakOrganizationBankInfoEdit} />,
          key: Permission.PEAK_ORGANIZATION_BANK_INFO_EDIT,
        },
        {
          title: <FormattedMessage {...messages.peakOrganizationBillingView} />,
          key: Permission.PEAK_ORGANIZATION_BILLING_INFO_VIEW,
        },
        {
          title: <FormattedMessage {...messages.peakOrganizationBillingEdit} />,
          key: Permission.PEAK_ORGANIZATION_BILLING_INFO_EDIT,
        },
        {
          title: <FormattedMessage {...messages.peakOrganizationFeeRatesView} />,
          key: Permission.PEAK_ORGANIZATION_FEE_RATES_VIEW,
        },
        {
          title: <FormattedMessage {...messages.peakOrganizationFeeRatesEdit} />,
          key: Permission.PEAK_ORGANIZATION_FEE_RATES_EDIT,
        },
        {
          title: <FormattedMessage {...messages.peakOrganizationProcessorConfigView} />,
          key: Permission.PEAK_ORGANIZATION_PROCESSOR_CONFIGURATION_VIEW,
        },
        {
          title: <FormattedMessage {...messages.peakOrganizationProcessorConfigEdit} />,
          key: Permission.PEAK_ORGANIZATION_PROCESSOR_CONFIGURATION_EDIT,
        },
        {
          title: <FormattedMessage {...messages.peakOrganizationTaxpayerView} />,
          key: Permission.PEAK_ORGANIZATION_TAXES_INFO_VIEW,
        },
        {
          title: <FormattedMessage {...messages.peakOrganizationTaxpayerEdit} />,
          key: Permission.PEAK_ORGANIZATION_TAXES_INFO_EDIT,
        },
        {
          title: <FormattedMessage {...messages.peakOrganizationIntegrationsView} />,
          key: Permission.PEAK_ORGANIZATION_INTEGRATION_VIEW,
        },
        {
          title: <FormattedMessage {...messages.peakOrganizationIntegrationsEdit} />,
          key: Permission.PEAK_ORGANIZATION_INTEGRATION_EDIT,
        },
        {
          title: <FormattedMessage {...messages.peakOrganizationIntegrationsChangeStatus} />,
          key: Permission.PEAK_ORGANIZATION_INTEGRATION_CHANGE_STATUS,
        },
        {
          title: <FormattedMessage {...messages.peakOrganizationOtherView} />,
          key: Permission.PEAK_ORGANIZATION_OTHER_VIEW,
        },
        {
          title: <FormattedMessage {...messages.peakOrganizationOtherEdit} />,
          key: Permission.PEAK_ORGANIZATION_OTHER_EDIT,
        },
        {
          title: <FormattedMessage {...messages.peakOrganizationRequiredFieldsView} />,
          key: Permission.PEAK_ORGANIZATION_REQUIRED_FIELDS_VIEW,
        },
        {
          title: <FormattedMessage {...messages.peakOrganizationRequiredFieldsEdit} />,
          key: Permission.PEAK_ORGANIZATION_REQUIRED_FIELDS_EDIT,
        },
        {
          title: <FormattedMessage {...messages.peakOrganizationPayPeriodSettingsView} />,
          key: Permission.PEAK_ORGANIZATION_PAY_PERIOD_SETTINGS_VIEW,
        },
        {
          title: <FormattedMessage {...messages.peakOrganizationPayPeriodSettingsCreate} />,
          key: Permission.PEAK_ORGANIZATION_PAY_PERIOD_SETTINGS_CREATE,
        },
        {
          title: <FormattedMessage {...messages.peakOrganizationPayPeriodSettingsEdit} />,
          key: Permission.PEAK_ORGANIZATION_PAY_PERIOD_SETTINGS_EDIT,
        },
        {
          title: <FormattedMessage {...messages.peakOrganizationPayPeriodView} />,
          key: Permission.PEAK_ORGANIZATION_PAY_PERIOD_VIEW,
        },
        {
          title: <FormattedMessage {...messages.peakOrganizationPayPeriodEdit} />,
          key: Permission.PEAK_ORGANIZATION_PAY_PERIOD_EDIT,
        },
        {
          title: <FormattedMessage {...messages.peakOrganizationPayPeriodChangeStatus} />,
          key: Permission.PEAK_ORGANIZATION_PAY_PERIOD_CHANGE_STATUS,
        },
        {
          title: <FormattedMessage {...messages.peakSettingsIntegrationView} />,
          key: Permission.PEAK_SETTINGS_INTEGRATION_VIEW,
        },
        {
          title: <FormattedMessage {...messages.peakSettingsIntegrationEdit} />,
          key: Permission.PEAK_SETTINGS_INTEGRATION_EDIT,
        },
        {
          title: <FormattedMessage {...messages.peakSettingsIntegrationChangeStatus} />,
          key: Permission.PEAK_SETTINGS_INTEGRATION_CHANGE_STATUS,
        },
        {
          title: <FormattedMessage {...messages.peakSettingsGeneralView} />,
          key: Permission.PEAK_SETTINGS_GENERAL_VIEW,
        },
        {
          title: <FormattedMessage {...messages.peakSettingsGeneralEdit} />,
          key: Permission.PEAK_SETTINGS_GENERAL_EDIT,
        },
        {
          title: <FormattedMessage {...messages.adjustmentCategoryView} />,
          key: Permission.PEAK_ADJUSTMENT_CATEGORY_VIEW,
        },
        {
          title: <FormattedMessage {...messages.adjustmentCategoryCreate} />,
          key: Permission.PEAK_ADJUSTMENT_CATEGORY_CREATE,
        },
        {
          title: <FormattedMessage {...messages.adjustmentCategoryEdit} />,
          key: Permission.PEAK_ADJUSTMENT_CATEGORY_EDIT,
        },
        {
          title: <FormattedMessage {...messages.clientAdjustmentsView} />,
          key: Permission.PEAK_CLIENT_ADJUSTMENTS_VIEW,
        },
        {
          title: <FormattedMessage {...messages.clientAdjustmentsCreate} />,
          key: Permission.PEAK_CLIENT_ADJUSTMENTS_CREATE,
        },
        {
          title: <FormattedMessage {...messages.clientAdjustmentsEdit} />,
          key: Permission.PEAK_CLIENT_ADJUSTMENTS_EDIT,
        },
        {
          title: <FormattedMessage {...messages.clientAdjustmentsChangeStatus} />,
          key: Permission.PEAK_CLIENT_ADJUSTMENTS_CHANGE_STATUS,
        },
        {
          title: <FormattedMessage {...messages.clientAdjustmentsExport} />,
          key: Permission.PEAK_CLIENT_ADJUSTMENTS_EXPORT,
        },
        {
          title: <FormattedMessage {...messages.recurringClientAdjustmentsView} />,
          key: Permission.PEAK_RECURRING_CLIENT_ADJUSTMENTS_VIEW,
        },
        {
          title: <FormattedMessage {...messages.recurringClientAdjustmentsCreate} />,
          key: Permission.PEAK_RECURRING_CLIENT_ADJUSTMENTS_CREATE,
        },
        {
          title: <FormattedMessage {...messages.recurringClientAdjustmentsEdit} />,
          key: Permission.PEAK_RECURRING_CLIENT_ADJUSTMENTS_EDIT,
        },
        {
          title: <FormattedMessage {...messages.recurringClientAdjustmentsChangeStatus} />,
          key: Permission.PEAK_RECURRING_CLIENT_ADJUSTMENTS_CHANGE_STATUS,
        },
        {
          title: <FormattedMessage {...messages.recurringClientAdjustmentsExport} />,
          key: Permission.PEAK_RECURRING_CLIENT_ADJUSTMENTS_EXPORT,
        },
        {
          title: <FormattedMessage {...messages.peakRemittanceCalculateView} />,
          key: Permission.PEAK_REMITTANCE_VIEW,
        },
        {
          title: <FormattedMessage {...messages.peakRemittanceCalculatePost} />,
          key: Permission.PEAK_REMITTANCE_CALCULATE,
        },
        {
          title: <FormattedMessage {...messages.peakRemittanceCalculateCancel} />,
          key: Permission.PEAK_REMITTANCE_CANCEL,
        },
        {
          title: <FormattedMessage {...messages.peakRemittanceCalculateDownload} />,
          key: Permission.PEAK_REMITTANCE_DOWNLOAD,
        },
        {
          title: <FormattedMessage {...messages.peakRemittanceCalculateSend} />,
          key: Permission.PEAK_REMITTANCE_SEND,
        },
        {
          title: <FormattedMessage {...messages.peakRemittanceCalculateFinalize} />,
          key: Permission.PEAK_REMITTANCE_FINALIZE,
        },
        {
          title: <FormattedMessage {...messages.peakOrganizationServicesView} />,
          key: Permission.PEAK_ORGANIZATION_SERVICES_VIEW,
        },
        {
          title: <FormattedMessage {...messages.peakOrganizationServicesEdit} />,
          key: Permission.PEAK_ORGANIZATION_SERVICES_EDIT,
        },
      ],
    },
  ],
};

export const PermissionsArrayCorporateOrClubLevel: IPermissionsArray<PermissionGroupsCorporateOrClubLevel> = {
  [PermissionGroupsCorporateOrClubLevel.SCHEDULING]: [
    {
      title: PermissionsGroupsLabels[PermissionGroupsCorporateOrClubLevel.SCHEDULING],
      key: PermissionGroupsCorporateOrClubLevel.SCHEDULING,
      children: [
        {
          title: <FormattedMessage {...messages.bookingEventsView} />,
          key: Permission.BOOKING_EVENTS_VIEW,
        },
        {
          title: <FormattedMessage {...messages.bookingEventsViewOne} />,
          key: Permission.BOOKING_EVENTS_VIEW_ONE,
        },
        {
          title: <FormattedMessage {...messages.bookingEventsCreate} />,
          key: Permission.BOOKING_EVENTS_CREATE,
        },
        {
          title: <FormattedMessage {...messages.bookingEventsEdit} />,
          key: Permission.BOOKING_EVENTS_EDIT,
        },
        {
          title: <FormattedMessage {...messages.bookingEventsCancel} />,
          key: Permission.BOOKING_EVENTS_CANCEL,
        },
        {
          title: <FormattedMessage {...messages.bookingEventsDelete} />,
          key: Permission.BOOKING_EVENTS_DELETE,
        },
        {
          title: <FormattedMessage {...messages.bookingEventsDuplicate} />,
          key: Permission.BOOKING_EVENTS_DUPLICATE,
        },
        {
          title: <FormattedMessage {...messages.bookingEventsRemindParticipants} />,
          key: Permission.BOOKING_EVENTS_REMIND_PARTICIPANTS,
        },
        {
          title: <FormattedMessage {...messages.bookingEventsNotSelfEdit} />,
          key: Permission.BOOKING_EVENTS_NOT_SELF_EDIT,
        },
        {
          title: <FormattedMessage {...messages.bookingResourcesView} />,
          key: Permission.BOOKING_RESOURCES_VIEW,
        },
        {
          title: <FormattedMessage {...messages.bookingResourcesCreate} />,
          key: Permission.BOOKING_RESOURCES_CREATE,
        },
        {
          title: <FormattedMessage {...messages.bookingResourcesEdit} />,
          key: Permission.BOOKING_RESOURCES_EDIT,
        },
        {
          title: <FormattedMessage {...messages.bookingResourcesChangeStatus} />,
          key: Permission.BOOKING_RESOURCES_CHANGE_STATUS,
        },
        {
          title: <FormattedMessage {...messages.bookingAppointmentsView} />,
          key: Permission.BOOKING_APPOINTMENTS_VIEW,
        },
      ],
    },
  ],
  [PermissionGroupsCorporateOrClubLevel.CRM]: [
    {
      title: PermissionsGroupsLabels[PermissionGroupsCorporateOrClubLevel.CRM],
      key: PermissionGroupsCorporateOrClubLevel.CRM,
      children: [
        {
          title: <FormattedMessage {...messages.crmTaskView} />,
          key: Permission.CRM_TASK_VIEW,
        },
        {
          title: <FormattedMessage {...messages.crmTaskViewOwn} />,
          key: Permission.CRM_TASK_VIEW_OWN,
        },
        {
          title: <FormattedMessage {...messages.crmTaskEditStatus} />,
          key: Permission.CRM_TASK_EDIT_STATUS,
        },
        {
          title: <FormattedMessage {...messages.crmTaskEditSalesperson} />,
          key: Permission.CRM_TASK_EDIT_SALESPERSON,
        },
        {
          title: <FormattedMessage {...messages.crmLeadView} />,
          key: Permission.CRM_LEAD_VIEW,
        },
        {
          title: <FormattedMessage {...messages.crmLeadViewOwn} />,
          key: Permission.CRM_LEAD_VIEW_OWN,
        },
        {
          title: <FormattedMessage {...messages.crmLeadCreate} />,
          key: Permission.CRM_LEAD_CREATE,
        },
        {
          title: <FormattedMessage {...messages.crmLeadEdit} />,
          key: Permission.CRM_LEAD_EDIT,
        },
        {
          title: <FormattedMessage {...messages.crmLeadEditStatus} />,
          key: Permission.CRM_LEAD_EDIT_STATUS,
        },
        {
          title: <FormattedMessage {...messages.crmLeadEditSalesperson} />,
          key: Permission.CRM_LEAD_EDIT_SALESPERSON,
        },
        {
          title: <FormattedMessage {...messages.crmLeadEditMembership} />,
          key: Permission.CRM_LEAD_EDIT_MEMBERSHIP,
        },
        {
          title: <FormattedMessage {...messages.crmScriptView} />,
          key: Permission.CRM_SCRIPT_VIEW,
        },
        {
          title: <FormattedMessage {...messages.crmScriptCreate} />,
          key: Permission.CRM_SCRIPT_CREATE,
        },
        {
          title: <FormattedMessage {...messages.crmScriptEdit} />,
          key: Permission.CRM_SCRIPT_EDIT,
        },
        {
          title: <FormattedMessage {...messages.crmScriptChangeStatus} />,
          key: Permission.CRM_SCRIPT_CHANGE_STATUS,
        },
        {
          title: <FormattedMessage {...messages.crmCampaignView} />,
          key: Permission.CRM_CAMPAIGN_VIEW,
        },
        {
          title: <FormattedMessage {...messages.crmCampaignCreate} />,
          key: Permission.CRM_CAMPAIGN_CREATE,
        },
        {
          title: <FormattedMessage {...messages.crmCampaignEdit} />,
          key: Permission.CRM_CAMPAIGN_EDIT,
        },
        {
          title: <FormattedMessage {...messages.crmCampaignChangeStatus} />,
          key: Permission.CRM_CAMPAIGN_CHANGE_STATUS,
        },
        {
          title: <FormattedMessage {...messages.crmSmsTemplateView} />,
          key: Permission.CRM_SMS_TEMPLATE_VIEW,
        },
        {
          title: <FormattedMessage {...messages.crmSmsTemplateCreate} />,
          key: Permission.CRM_SMS_TEMPLATE_CREATE,
        },
        {
          title: <FormattedMessage {...messages.crmSmsTemplateEdit} />,
          key: Permission.CRM_SMS_TEMPLATE_EDIT,
        },
        {
          title: <FormattedMessage {...messages.crmSmsTemplateChangeStatus} />,
          key: Permission.CRM_SMS_TEMPLATE_CHANGE_STATUS,
        },
        {
          title: <FormattedMessage {...messages.crmEmailTemplateView} />,
          key: Permission.CRM_EMAIL_TEMPLATE_VIEW,
        },
        {
          title: <FormattedMessage {...messages.crmEmailTemplateCreate} />,
          key: Permission.CRM_EMAIL_TEMPLATE_CREATE,
        },
        {
          title: <FormattedMessage {...messages.crmEmailTemplateEdit} />,
          key: Permission.CRM_EMAIL_TEMPLATE_EDIT,
        },
        {
          title: <FormattedMessage {...messages.crmEmailTemplateChangeStatus} />,
          key: Permission.CRM_EMAIL_TEMPLATE_CHANGE_STATUS,
        },
      ],
    },
  ],
  [PermissionGroupsCorporateOrClubLevel.PT_CRM]: [
    {
      title: PermissionsGroupsLabels[PermissionGroupsCorporateOrClubLevel.PT_CRM],
      key: PermissionGroupsCorporateOrClubLevel.PT_CRM,
      children: [
        {
          title: <FormattedMessage {...messages.ptCrmTaskView} />,
          key: Permission.PT_CRM_TASK_VIEW,
        },
        {
          title: <FormattedMessage {...messages.ptCrmTaskViewOwn} />,
          key: Permission.PT_CRM_TASK_VIEW_OWN,
        },
        {
          title: <FormattedMessage {...messages.ptCrmTaskEditStatus} />,
          key: Permission.PT_CRM_TASK_EDIT_STATUS,
        },
        {
          title: <FormattedMessage {...messages.ptCrmTaskEditSalesperson} />,
          key: Permission.PT_CRM_TASK_EDIT_SALESPERSON,
        },
        {
          title: <FormattedMessage {...messages.ptCrmLeadView} />,
          key: Permission.PT_CRM_LEAD_VIEW,
        },
        {
          title: <FormattedMessage {...messages.ptCrmLeadViewOwn} />,
          key: Permission.PT_CRM_LEAD_VIEW_OWN,
        },
        {
          title: <FormattedMessage {...messages.ptCrmLeadCreate} />,
          key: Permission.PT_CRM_LEAD_CREATE,
        },
        {
          title: <FormattedMessage {...messages.ptCrmLeadEdit} />,
          key: Permission.PT_CRM_LEAD_EDIT,
        },
        {
          title: <FormattedMessage {...messages.ptCrmLeadEditStatus} />,
          key: Permission.PT_CRM_LEAD_EDIT_STATUS,
        },
        {
          title: <FormattedMessage {...messages.ptCrmLeadEditSalesperson} />,
          key: Permission.PT_CRM_LEAD_EDIT_SALESPERSON,
        },
        {
          title: <FormattedMessage {...messages.ptCrmLeadEditMembership} />,
          key: Permission.PT_CRM_LEAD_EDIT_MEMBERSHIP,
        },
        {
          title: <FormattedMessage {...messages.ptCrmScriptView} />,
          key: Permission.PT_CRM_SCRIPT_VIEW,
        },
        {
          title: <FormattedMessage {...messages.ptCrmScriptCreate} />,
          key: Permission.PT_CRM_SCRIPT_CREATE,
        },
        {
          title: <FormattedMessage {...messages.ptCrmScriptEdit} />,
          key: Permission.PT_CRM_SCRIPT_EDIT,
        },
        {
          title: <FormattedMessage {...messages.ptCrmScriptChangeStatus} />,
          key: Permission.PT_CRM_SCRIPT_CHANGE_STATUS,
        },
        {
          title: <FormattedMessage {...messages.ptCrmCampaignView} />,
          key: Permission.PT_CRM_CAMPAIGN_VIEW,
        },
        {
          title: <FormattedMessage {...messages.ptCrmCampaignCreate} />,
          key: Permission.PT_CRM_CAMPAIGN_CREATE,
        },
        {
          title: <FormattedMessage {...messages.ptCrmCampaignEdit} />,
          key: Permission.PT_CRM_CAMPAIGN_EDIT,
        },
        {
          title: <FormattedMessage {...messages.ptCrmCampaignChangeStatus} />,
          key: Permission.PT_CRM_CAMPAIGN_CHANGE_STATUS,
        },
        {
          title: <FormattedMessage {...messages.ptCrmSmsTemplateView} />,
          key: Permission.PT_CRM_SMS_TEMPLATE_VIEW,
        },
        {
          title: <FormattedMessage {...messages.ptCrmSmsTemplateCreate} />,
          key: Permission.PT_CRM_SMS_TEMPLATE_CREATE,
        },
        {
          title: <FormattedMessage {...messages.ptCrmSmsTemplateEdit} />,
          key: Permission.PT_CRM_SMS_TEMPLATE_EDIT,
        },
        {
          title: <FormattedMessage {...messages.ptCrmSmsTemplateChangeStatus} />,
          key: Permission.PT_CRM_SMS_TEMPLATE_CHANGE_STATUS,
        },
        {
          title: <FormattedMessage {...messages.ptCrmEmailTemplateView} />,
          key: Permission.PT_CRM_EMAIL_TEMPLATE_VIEW,
        },
        {
          title: <FormattedMessage {...messages.ptCrmEmailTemplateCreate} />,
          key: Permission.PT_CRM_EMAIL_TEMPLATE_CREATE,
        },
        {
          title: <FormattedMessage {...messages.ptCrmEmailTemplateEdit} />,
          key: Permission.PT_CRM_EMAIL_TEMPLATE_EDIT,
        },
        {
          title: <FormattedMessage {...messages.ptCrmEmailTemplateChangeStatus} />,
          key: Permission.PT_CRM_EMAIL_TEMPLATE_CHANGE_STATUS,
        },
      ],
    },
  ],
  [PermissionGroupsCorporateOrClubLevel.POS_CONTENT]: [
    {
      title: PermissionsGroupsLabels[PermissionGroupsCorporateOrClubLevel.POS_CONTENT],
      key: PermissionGroupsCorporateOrClubLevel.POS_CONTENT,
      children: [
        {
          title: <FormattedMessage {...messages.corporateReceiptTemplatesView} />,
          key: Permission.RECEIPT_TEMPLATES_VIEW,
        },
        {
          title: <FormattedMessage {...messages.corporateReceiptTemplatesViewOne} />,
          key: Permission.RECEIPT_TEMPLATES_VIEW_ONE,
        },
        {
          title: <FormattedMessage {...messages.corporateReceiptTemplatesCreate} />,
          key: Permission.RECEIPT_TEMPLATES_CREATE,
        },
        {
          title: <FormattedMessage {...messages.corporateReceiptTemplatesEdit} />,
          key: Permission.RECEIPT_TEMPLATES_EDIT,
        },
        {
          title: <FormattedMessage {...messages.corporateReceiptTemplatesChangeStatus} />,
          key: Permission.RECEIPT_TEMPLATES_CHANGE_STATUS,
        },

        {
          title: <FormattedMessage {...messages.corporateTaxRateView} />,
          key: Permission.TAX_RATE_VIEW,
        },
        {
          title: <FormattedMessage {...messages.corporateTaxRateCreate} />,
          key: Permission.TAX_RATE_CREATE,
        },
        {
          title: <FormattedMessage {...messages.corporateTaxRateEdit} />,
          key: Permission.TAX_RATE_EDIT,
        },
        {
          title: <FormattedMessage {...messages.corporateTaxRateChangeStatus} />,
          key: Permission.TAX_RATE_CHANGE_STATUS,
        },
        {
          title: <FormattedMessage {...messages.corporateRevenueCodeView} />,
          key: Permission.REVENUE_CODE_VIEW,
        },
        {
          title: <FormattedMessage {...messages.corporateRevenueCodeCreate} />,
          key: Permission.REVENUE_CODE_CREATE,
        },
        {
          title: <FormattedMessage {...messages.corporateRevenueCodeEdit} />,
          key: Permission.REVENUE_CODE_EDIT,
        },
        {
          title: <FormattedMessage {...messages.corporateRevenueCodeChangeStatus} />,
          key: Permission.REVENUE_CODE_CHANGE_STATUS,
        },
        {
          title: <FormattedMessage {...messages.corporateVendorView} />,
          key: Permission.VENDOR_VIEW,
        },
        {
          title: <FormattedMessage {...messages.corporateVendorViewOne} />,
          key: Permission.VENDOR_VIEW_ONE,
        },
        {
          title: <FormattedMessage {...messages.corporateVendorCreate} />,
          key: Permission.VENDOR_CREATE,
        },
        {
          title: <FormattedMessage {...messages.corporateVendorEdit} />,
          key: Permission.VENDOR_EDIT,
        },
        {
          title: <FormattedMessage {...messages.corporateVendorChangeStatus} />,
          key: Permission.VENDOR_CHANGE_STATUS,
        },
        {
          title: <FormattedMessage {...messages.corporateInventoryView} />,
          key: Permission.INVENTORY_VIEW,
        },
        {
          title: <FormattedMessage {...messages.corporateInventoryViewOne} />,
          key: Permission.INVENTORY_VIEW_ONE,
        },
        {
          title: <FormattedMessage {...messages.corporateInventoryCreate} />,
          key: Permission.INVENTORY_CREATE,
        },
        {
          title: <FormattedMessage {...messages.corporateInventoryEdit} />,
          key: Permission.INVENTORY_EDIT,
        },
        {
          title: <FormattedMessage {...messages.corporateInventoryChangeStatus} />,
          key: Permission.INVENTORY_CHANGE_STATUS,
        },
        {
          title: <FormattedMessage {...messages.corporateRegisterView} />,
          key: Permission.REGISTER_VIEW,
        },
        {
          title: <FormattedMessage {...messages.corporateRegisterViewOne} />,
          key: Permission.REGISTER_VIEW_ONE,
        },
        {
          title: <FormattedMessage {...messages.corporateRegisterCreate} />,
          key: Permission.REGISTER_CREATE,
        },
        {
          title: <FormattedMessage {...messages.corporateRegisterEdit} />,
          key: Permission.REGISTER_EDIT,
        },
        {
          title: <FormattedMessage {...messages.corporateRegisterChangeStatus} />,
          key: Permission.REGISTER_CHANGE_STATUS,
        },
        {
          title: <FormattedMessage {...messages.corporateDefaultPaymentMethodView} />,
          key: Permission.DEFAULT_PAYMENT_METHOD_VIEW,
        },
        {
          title: <FormattedMessage {...messages.corporateDefaultPaymentMethodEdit} />,
          key: Permission.DEFAULT_PAYMENT_METHOD_EDIT,
        },
        {
          title: <FormattedMessage {...messages.corporateDefaultPaymentMethodChangeStatus} />,
          key: Permission.DEFAULT_PAYMENT_METHOD_CHANGE_STATUS,
        },
        {
          title: <FormattedMessage {...messages.corporateCustomPaymentMethodView} />,
          key: Permission.CUSTOM_PAYMENT_METHOD_VIEW,
        },
        {
          title: <FormattedMessage {...messages.corporateCustomPaymentMethodViewOne} />,
          key: Permission.CUSTOM_PAYMENT_METHOD_VIEW_ONE,
        },
        {
          title: <FormattedMessage {...messages.corporateCustomPaymentMethodCreate} />,
          key: Permission.CUSTOM_PAYMENT_METHOD_CREATE,
        },
        {
          title: <FormattedMessage {...messages.corporateCustomPaymentMethodEdit} />,
          key: Permission.CUSTOM_PAYMENT_METHOD_EDIT,
        },
        {
          title: <FormattedMessage {...messages.corporateCustomPaymentMethodChangeStatus} />,
          key: Permission.CUSTOM_PAYMENT_METHOD_CHANGE_STATUS,
        },
      ],
    },
  ],
  [PermissionGroupsCorporateOrClubLevel.MEMBER_MANAGEMENT]: [
    {
      title: PermissionsGroupsLabels[PermissionGroupsCorporateOrClubLevel.MEMBER_MANAGEMENT],
      key: PermissionGroupsCorporateOrClubLevel.MEMBER_MANAGEMENT,
      children: [
        {
          title: <FormattedMessage {...messages.memberView} />,
          key: Permission.MEMBER_VIEW,
        },
        {
          title: <FormattedMessage {...messages.memberViewOne} />,
          key: Permission.MEMBER_VIEW_ONE,
        },
        {
          title: <FormattedMessage {...messages.memberCreate} />,
          key: Permission.MEMBER_CREATE,
        },
        {
          title: <FormattedMessage {...messages.memberEdit} />,
          key: Permission.MEMBER_EDIT,
        },
        {
          title: <FormattedMessage {...messages.memberRewardPointEdit} />,
          key: Permission.MEMBER_REWARD_POINT_EDIT,
        },
        {
          title: <FormattedMessage {...messages.memberSessionRedeem} />,
          key: Permission.MEMBER_SESSION_REDEEM,
        },
        {
          title: <FormattedMessage {...messages.memberSessionUnredeem} />,
          key: Permission.MEMBER_SESSION_UNREDEEM,
        },
        {
          title: <FormattedMessage {...messages.memberServiceFreeze} />,
          key: Permission.MEMBER_SERVICE_FREEZE,
        },
        {
          title: <FormattedMessage {...messages.memberWaiveFee} />,
          key: Permission.MEMBER_WAIVE_FEE,
        },
        {
          title: <FormattedMessage {...messages.memberViewDocuments} />,
          key: Permission.MEMBER_VIEW_DOCUMENTS,
        },
        {
          title: <FormattedMessage {...messages.memberUploadDocuments} />,
          key: Permission.MEMBER_UPLOAD_DOCUMENTS,
        },
        {
          title: <FormattedMessage {...messages.memberAlertManageSettings} />,
          key: Permission.MEMBER_ALERT_MANAGE_SETTINGS,
        },
        {
          title: <FormattedMessage {...messages.memberAlertResolve} />,
          key: Permission.MEMBER_ALERT_RESOLVE,
        },
      ],
    },
  ],
  [PermissionGroupsCorporateOrClubLevel.EMPLOYEE_MANAGEMENT]: [
    {
      title: PermissionsGroupsLabels[PermissionGroupsCorporateOrClubLevel.EMPLOYEE_MANAGEMENT],
      key: PermissionGroupsCorporateOrClubLevel.EMPLOYEE_MANAGEMENT,
      children: [
        {
          title: <FormattedMessage {...messages.employeeView} />,
          key: Permission.EMPLOYEE_VIEW,
        },
        {
          title: <FormattedMessage {...messages.employeeCreate} />,
          key: Permission.EMPLOYEE_CREATE,
        },
        {
          title: <FormattedMessage {...messages.employeeEdit} />,
          key: Permission.EMPLOYEE_EDIT,
        },
        {
          title: <FormattedMessage {...messages.employeeChangeStatus} />,
          key: Permission.EMPLOYEE_CHANGE_STATUS,
        },
        {
          title: <FormattedMessage {...messages.employeeUpdatePermissions} />,
          key: Permission.EMPLOYEE_UPDATE_PERMISSIONS,
        },
        {
          title: <FormattedMessage {...messages.employeeTakePhoto} />,
          key: Permission.EMPLOYEE_TAKE_PHOTO,
        },
        {
          title: <FormattedMessage {...messages.employeeViewDocuments} />,
          key: Permission.EMPLOYEE_VIEW_DOCUMENTS,
        },
        {
          title: <FormattedMessage {...messages.employeeUploadDocuments} />,
          key: Permission.EMPLOYEE_UPLOAD_DOCUMENTS,
        },
      ],
    },
  ],
  [PermissionGroupsCorporateOrClubLevel.TIME_CLOCK]: [
    {
      title: PermissionsGroupsLabels[PermissionGroupsCorporateOrClubLevel.TIME_CLOCK],
      key: PermissionGroupsCorporateOrClubLevel.TIME_CLOCK,
      children: [
        {
          title: <FormattedMessage {...messages.timeClockView} />,
          key: Permission.TIME_CLOCK_VIEW,
        },
        {
          title: <FormattedMessage {...messages.timeClockViewOwn} />,
          key: Permission.TIME_CLOCK_VIEW_OWN,
        },
        {
          title: <FormattedMessage {...messages.timeClockDelete} />,
          key: Permission.TIME_CLOCK_DELETE,
        },
        {
          title: <FormattedMessage {...messages.timeClockIn} />,
          key: Permission.TIME_CLOCK_IN,
        },
        {
          title: <FormattedMessage {...messages.timeClockOut} />,
          key: Permission.TIME_CLOCK_OUT,
        },
        {
          title: <FormattedMessage {...messages.timeClockPayrollReportView} />,
          key: Permission.TIME_CLOCK_PAYROLL_REPORT_VIEW,
        },
        {
          title: <FormattedMessage {...messages.timeClockPayrollReportViewOwn} />,
          key: Permission.TIME_CLOCK_PAYROLL_REPORT_VIEW_OWN,
        },
        {
          title: <FormattedMessage {...messages.timeClockPayrollReportExport} />,
          key: Permission.TIME_CLOCK_PAYROLL_REPORT_EXPORT,
        },
        {
          title: <FormattedMessage {...messages.timeClockPayrollReportDelete} />,
          key: Permission.TIME_CLOCK_PAYROLL_REPORT_DELETE,
        },
      ],
    },
  ],
  [PermissionGroupsCorporateOrClubLevel.REPORTING]: [
    {
      title: PermissionsGroupsLabels[PermissionGroupsCorporateOrClubLevel.REPORTING],
      key: PermissionGroupsCorporateOrClubLevel.REPORTING,
      children: [
        {
          title: <FormattedMessage {...messages.reportsView} />,
          key: Permission.REPORTS_VIEW,
        },
        {
          title: <FormattedMessage {...messages.reportsExport} />,
          key: Permission.REPORTS_EXPORT,
        },
        {
          title: <FormattedMessage {...messages.overviewReportView} />,
          key: Permission.OVERVIEW_REPORT_VIEW,
        },
        {
          title: <FormattedMessage {...messages.overviewReportExport} />,
          key: Permission.OVERVIEW_REPORT_EXPORT,
        },
        {
          title: <FormattedMessage {...messages.externalCollectionReportView} />,
          key: Permission.EXTERNAL_COLLECTIONS_REPORT_VIEW,
        },
        {
          title: <FormattedMessage {...messages.externalCollectionReportExport} />,
          key: Permission.EXTERNAL_COLLECTIONS_REPORT_EXPORT,
        },
        {
          title: <FormattedMessage {...messages.salesReportView} />,
          key: Permission.SALES_REPORT_VIEW,
        },
        {
          title: <FormattedMessage {...messages.salesReportEdit} />,
          key: Permission.SALES_REPORT_EDIT,
        },
        {
          title: <FormattedMessage {...messages.salesReportExport} />,
          key: Permission.SALES_REPORT_EXPORT,
        },
        {
          title: <FormattedMessage {...messages.invoiceReportView} />,
          key: Permission.INVOICE_REPORT_VIEW,
        },
        {
          title: <FormattedMessage {...messages.invoiceReportDetailedView} />,
          key: Permission.INVOICE_REPORT_DETAILED_VIEW,
        },
        {
          title: <FormattedMessage {...messages.invoiceReportExport} />,
          key: Permission.INVOICE_REPORT_EXPORT,
        },
        {
          title: <FormattedMessage {...messages.invoiceReportViewSnapshots} />,
          key: Permission.INVOICE_REPORT_VIEW_SNAPSHOTS,
        },
        {
          title: <FormattedMessage {...messages.invoiceReportMakeSnapshots} />,
          key: Permission.INVOICE_REPORT_MAKE_SNAPSHOT,
        },
        {
          title: <FormattedMessage {...messages.invoiceReportAssignMember} />,
          key: Permission.INVOICE_REPORT_ASSIGN_MEMBER,
        },
        {
          title: <FormattedMessage {...messages.invoiceReportVoid} />,
          key: Permission.INVOICE_REPORT_VOID,
        },
        {
          title: <FormattedMessage {...messages.zOutReportView} />,
          key: Permission.Z_REPORT_VIEW,
        },
        {
          title: <FormattedMessage {...messages.zOutReportDetailedView} />,
          key: Permission.Z_REPORT_DETAILED_VIEW,
        },
        {
          title: <FormattedMessage {...messages.zOutReportExport} />,
          key: Permission.Z_REPORT_EXPORT,
        },
        {
          title: <FormattedMessage {...messages.scheduledBillingsReportView} />,
          key: Permission.SCHEDULED_BILLINGS_REPORT_VIEW,
        },
        {
          title: <FormattedMessage {...messages.scheduledBillingsReportExport} />,
          key: Permission.SCHEDULED_BILLINGS_REPORT_EXPORT,
        },
        {
          title: <FormattedMessage {...messages.overTimeReportView} />,
          key: Permission.OVER_TIME_REPORT_VIEW,
        },
        {
          title: <FormattedMessage {...messages.overTimeReportExport} />,
          key: Permission.OVER_TIME_REPORT_EXPORT,
        },
        {
          title: <FormattedMessage {...messages.registerStatusReportView} />,
          key: Permission.REGISTER_STATUS_REPORT_VIEW,
        },
        {
          title: <FormattedMessage {...messages.registerStatusReportExport} />,
          key: Permission.REGISTER_STATUS_REPORT_EXPORT,
        },
        {
          title: <FormattedMessage {...messages.registerStatusReportClose} />,
          key: Permission.REGISTER_STATUS_REPORT_CLOSE,
        },
        {
          title: <FormattedMessage {...messages.transactionReportView} />,
          key: Permission.TRANSACTION_REPORT_VIEW,
        },
        {
          title: <FormattedMessage {...messages.transactionReportExport} />,
          key: Permission.TRANSACTION_REPORT_EXPORT,
        },
        {
          title: <FormattedMessage {...messages.redemptionReportView} />,
          key: Permission.REDEMPTION_REPORT_VIEW,
        },
        {
          title: <FormattedMessage {...messages.redemptionReportExport} />,
          key: Permission.REDEMPTION_REPORT_EXPORT,
        },
        {
          title: <FormattedMessage {...messages.redemptionReportUnredeem} />,
          key: Permission.REDEMPTION_REPORT_UNREDEEM,
        },
        {
          title: <FormattedMessage {...messages.dashboardReportView} />,
          key: Permission.DASHBOARD_REPORT_VIEW,
        },
        {
          title: <FormattedMessage {...messages.dashboardReportExport} />,
          key: Permission.DASHBOARD_REPORT_EXPORT,
        },
        {
          title: <FormattedMessage {...messages.campaignReportView} />,
          key: Permission.CAMPAIGN_REPORT_VIEW,
        },
        {
          title: <FormattedMessage {...messages.campaignReportDetailedView} />,
          key: Permission.CAMPAIGN_REPORT_DETAILED_VIEW,
        },
        {
          title: <FormattedMessage {...messages.campaignReportExport} />,
          key: Permission.CAMPAIGN_REPORT_EXPORT,
        },
        {
          title: <FormattedMessage {...messages.appointmentReportView} />,
          key: Permission.APPOINTMENT_REPORT_VIEW,
        },
        {
          title: <FormattedMessage {...messages.appointmentReportDetailedView} />,
          key: Permission.APPOINTMENT_REPORT_DETAILED_VIEW,
        },
        {
          title: <FormattedMessage {...messages.appointmentReportExport} />,
          key: Permission.APPOINTMENT_REPORT_EXPORT,
        },
        {
          title: <FormattedMessage {...messages.checkInHistoryReportView} />,
          key: Permission.CHECK_IN_HISTORY_REPORT_VIEW,
        },
        {
          title: <FormattedMessage {...messages.checkInHistoryReportExport} />,
          key: Permission.CHECK_IN_HISTORY_REPORT_EXPORT,
        },
        {
          title: <FormattedMessage {...messages.kidZoneCheckInHistoryReportView} />,
          key: Permission.KID_ZONE_CHECK_IN_HISTORY_REPORT_VIEW,
        },
        {
          title: <FormattedMessage {...messages.kidZoneCheckInHistoryReportExport} />,
          key: Permission.KID_ZONE_CHECK_IN_HISTORY_REPORT_EXPORT,
        },
      ],
    },
  ],
  [PermissionGroupsCorporateOrClubLevel.SALES_MANAGEMENT]: [
    {
      title: PermissionsGroupsLabels[PermissionGroupsCorporateOrClubLevel.SALES_MANAGEMENT],
      key: PermissionGroupsCorporateOrClubLevel.SALES_MANAGEMENT,
      children: [
        {
          title: <FormattedMessage {...messages.viewLead} />,
          key: Permission.SALES_VIEW_LEADS,
        },
        {
          title: <FormattedMessage {...messages.editLead} />,
          key: Permission.SALES_EDIT_LEADS,
        },
        {
          title: <FormattedMessage {...messages.commissionRuleView} />,
          key: Permission.COMMISSION_RULE_VIEW,
        },
        {
          title: <FormattedMessage {...messages.commissionRuleCreate} />,
          key: Permission.COMMISSION_RULE_CREATE,
        },
        {
          title: <FormattedMessage {...messages.commissionRuleEdit} />,
          key: Permission.COMMISSION_RULE_EDIT,
        },
        {
          title: <FormattedMessage {...messages.commissionRuleDelete} />,
          key: Permission.COMMISSION_RULE_DELETE,
        },
        {
          title: <FormattedMessage {...messages.daysheetView} />,
          key: Permission.DAYSHEET_VIEW,
        },
      ],
    },
  ],
  [PermissionGroupsCorporateOrClubLevel.CLIENT_MANAGEMENT]: [
    {
      title: PermissionsGroupsLabels[PermissionGroupsCorporateOrClubLevel.CLIENT_MANAGEMENT],
      key: PermissionGroupsCorporateOrClubLevel.CLIENT_MANAGEMENT,
      children: [
        {
          title: <FormattedMessage {...messages.corporateClientView} />,
          key: Permission.CLIENT_LIST_VIEW,
        },
        {
          title: <FormattedMessage {...messages.corporateClientCreate} />,
          key: Permission.CLIENT_CREATE,
        },
        {
          title: <FormattedMessage {...messages.corporateClientChangeStatus} />,
          key: Permission.CLIENT_CHANGE_STATUS,
        },
        {
          title: <FormattedMessage {...messages.corporateClientGeneralInfoView} />,
          key: Permission.CLIENT_GENERAL_INFO_VIEW,
        },
        {
          title: <FormattedMessage {...messages.corporateClientGeneralInfoEdit} />,
          key: Permission.CLIENT_GENERAL_INFO_EDIT,
        },
        {
          title: <FormattedMessage {...messages.corporateClientBankInfoView} />,
          key: Permission.CLIENT_BANK_INFO_VIEW,
        },
        {
          title: <FormattedMessage {...messages.corporateClientBankInfoEdit} />,
          key: Permission.CLIENT_BANK_INFO_EDIT,
        },
        {
          title: <FormattedMessage {...messages.corporateClientBillingInfoView} />,
          key: Permission.CLIENT_BILLING_INFO_VIEW,
        },
        {
          title: <FormattedMessage {...messages.corporateClientBillingInfoEdit} />,
          key: Permission.CLIENT_BILLING_INFO_EDIT,
        },
        {
          title: <FormattedMessage {...messages.corporateClientFeeRatesView} />,
          key: Permission.CLIENT_FEE_RATES_VIEW,
        },
        {
          title: <FormattedMessage {...messages.corporateClientFeeRatesEdit} />,
          key: Permission.CLIENT_FEE_RATES_EDIT,
        },
        {
          title: <FormattedMessage {...messages.corporateClientProcessorConfigView} />,
          key: Permission.CLIENT_PROCESSOR_CONFIGURATION_VIEW,
        },
        {
          title: <FormattedMessage {...messages.corporateClientProcessorConfigEdit} />,
          key: Permission.CLIENT_PROCESSOR_CONFIGURATION_EDIT,
        },
        {
          title: <FormattedMessage {...messages.corporateClientTaxesInfoView} />,
          key: Permission.CLIENT_TAXES_INFO_VIEW,
        },
        {
          title: <FormattedMessage {...messages.corporateClientTaxesInfoEdit} />,
          key: Permission.CLIENT_TAXES_INFO_EDIT,
        },
        {
          title: <FormattedMessage {...messages.corporateClientIntegrationsView} />,
          key: Permission.CLIENT_INTEGRATION_VIEW,
        },
        {
          title: <FormattedMessage {...messages.corporateClientIntegrationsEdit} />,
          key: Permission.CLIENT_INTEGRATION_EDIT,
        },
        {
          title: <FormattedMessage {...messages.corporateClientOtherInfoView} />,
          key: Permission.CLIENT_OTHER_INFO_VIEW,
        },
        {
          title: <FormattedMessage {...messages.corporateClientOtherInfoEdit} />,
          key: Permission.CLIENT_OTHER_INFO_EDIT,
        },
        {
          title: <FormattedMessage {...messages.corporateClientWorkingHoursView} />,
          key: Permission.CLIENT_WORKING_HOURS_VIEW,
        },
        {
          title: <FormattedMessage {...messages.corporateClientWorkingHoursEdit} />,
          key: Permission.CLIENT_WORKING_HOURS_EDIT,
        },
        {
          title: <FormattedMessage {...messages.corporateClientKidzoneSettingsView} />,
          key: Permission.CLIENT_KIDZONE_SETTINGS_VIEW,
        },
        {
          title: <FormattedMessage {...messages.corporateClientKidzoneSettingsEdit} />,
          key: Permission.CLIENT_KIDZONE_SETTINGS_EDIT,
        },
        {
          title: <FormattedMessage {...messages.corporateClientKidzoneSettingsChangeStatus} />,
          key: Permission.CLIENT_KIDZONE_SETTINGS_CHANGE_STATUS,
        },
      ],
    },
  ],
  [PermissionGroupsCorporateOrClubLevel.SPAMBI]: [
    {
      title: PermissionsGroupsLabels[PermissionGroupsCorporateOrClubLevel.SPAMBI],
      key: PermissionGroupsCorporateOrClubLevel.SPAMBI,
      children: [
        {
          title: <FormattedMessage {...messages.clientAdjustmentsView} />,
          key: Permission.PEAK_CLIENT_ADJUSTMENTS_VIEW,
        },
        {
          title: <FormattedMessage {...messages.clientAdjustmentsCreate} />,
          key: Permission.PEAK_CLIENT_ADJUSTMENTS_CREATE,
        },
        {
          title: <FormattedMessage {...messages.clientAdjustmentsEdit} />,
          key: Permission.PEAK_CLIENT_ADJUSTMENTS_EDIT,
        },
        {
          title: <FormattedMessage {...messages.clientAdjustmentsChangeStatus} />,
          key: Permission.PEAK_CLIENT_ADJUSTMENTS_CHANGE_STATUS,
        },
        {
          title: <FormattedMessage {...messages.clientAdjustmentsExport} />,
          key: Permission.PEAK_CLIENT_ADJUSTMENTS_EXPORT,
        },
        {
          title: <FormattedMessage {...messages.clientServicesView} />,
          key: Permission.CLIENT_SERVICES_VIEW,
        },
        {
          title: <FormattedMessage {...messages.clientServicesEdit} />,
          key: Permission.CLIENT_SERVICES_EDIT,
        },
        {
          title: <FormattedMessage {...messages.recurringClientAdjustmentsView} />,
          key: Permission.PEAK_RECURRING_CLIENT_ADJUSTMENTS_VIEW,
        },
        {
          title: <FormattedMessage {...messages.recurringClientAdjustmentsCreate} />,
          key: Permission.PEAK_RECURRING_CLIENT_ADJUSTMENTS_CREATE,
        },
        {
          title: <FormattedMessage {...messages.recurringClientAdjustmentsEdit} />,
          key: Permission.PEAK_RECURRING_CLIENT_ADJUSTMENTS_EDIT,
        },
        {
          title: <FormattedMessage {...messages.recurringClientAdjustmentsChangeStatus} />,
          key: Permission.PEAK_RECURRING_CLIENT_ADJUSTMENTS_CHANGE_STATUS,
        },
        {
          title: <FormattedMessage {...messages.recurringClientAdjustmentsExport} />,
          key: Permission.PEAK_RECURRING_CLIENT_ADJUSTMENTS_EXPORT,
        },
      ],
    },
  ],
};

export const PermissionsArrayCorporateLevel: IPermissionsArray<PermissionGroupsCorporateLevel &
  PermissionGroupsCorporateOrClubLevel> = {
  [PermissionGroupsCorporateLevel.CORPORATE_LEVEL]: [
    {
      title: PermissionsGroupsLabels[PermissionGroupsCorporateLevel.CORPORATE_LEVEL],
      key: PermissionGroupsCorporateLevel.CORPORATE_LEVEL,
      children: [
        {
          title: <FormattedMessage {...messages.corporateSuperUser} />,
          key: Permission.CORPORATE_SU,
        },
      ],
    },
  ],
  [PermissionGroupsCorporateLevel.PERMISSIONS]: [
    {
      title: PermissionsGroupsLabels[PermissionGroupsCorporateLevel.PERMISSIONS],
      key: PermissionGroupsCorporateLevel.PERMISSIONS,
      children: [
        {
          title: <FormattedMessage {...messages.corporateSecurityRoleView} />,
          key: Permission.SECURITY_ROLE_VIEW,
        },
        {
          title: <FormattedMessage {...messages.corporateSecurityRoleCreate} />,
          key: Permission.SECURITY_ROLE_CREATE,
        },
        {
          title: <FormattedMessage {...messages.corporateSecurityRoleEdit} />,
          key: Permission.SECURITY_ROLE_EDIT,
        },
        {
          title: <FormattedMessage {...messages.corporateSecurityRoleChangeStatus} />,
          key: Permission.SECURITY_ROLE_CHANGE_STATUS,
        },
        {
          title: <FormattedMessage {...messages.corporateSecurityPolicyView} />,
          key: Permission.SECURITY_POLICY_VIEW,
        },
        {
          title: <FormattedMessage {...messages.corporateSecurityPolicyCreate} />,
          key: Permission.SECURITY_POLICY_CREATE,
        },
        {
          title: <FormattedMessage {...messages.corporateSecurityPolicyEdit} />,
          key: Permission.SECURITY_POLICY_EDIT,
        },
        {
          title: <FormattedMessage {...messages.corporateSecurityPolicyChangeStatus} />,
          key: Permission.SECURITY_POLICY_CHANGE_STATUS,
        },
      ],
    },
  ],
  [PermissionGroupsCorporateLevel.CORPORATE_MANAGEMENT]: [
    {
      title: PermissionsGroupsLabels[PermissionGroupsCorporateLevel.CORPORATE_MANAGEMENT],
      key: PermissionGroupsCorporateLevel.CORPORATE_MANAGEMENT,
      children: [
        {
          title: <FormattedMessage {...messages.corporateSignInAsSupportUser} />,
          key: Permission.CORPORATE_SIGN_IN_AS_SUPPORT_USER,
        },
        {
          title: <FormattedMessage {...messages.corporateTransferOwnership} />,
          key: Permission.CORPORATE_TRANSFER_OWNERSHIP,
        },
        {
          title: <FormattedMessage {...messages.corporateGeneralInfoView} />,
          key: Permission.CORPORATE_GENERAL_INFO_VIEW,
        },
        {
          title: <FormattedMessage {...messages.corporateGeneralInfoEdit} />,
          key: Permission.CORPORATE_GENERAL_INFO_EDIT,
        },
        {
          title: <FormattedMessage {...messages.corporateBankInfoView} />,
          key: Permission.CORPORATE_BANK_INFO_VIEW,
        },
        {
          title: <FormattedMessage {...messages.corporateBankInfoEdit} />,
          key: Permission.CORPORATE_BANK_INFO_EDIT,
        },
        {
          title: <FormattedMessage {...messages.corporateBillingInfoView} />,
          key: Permission.CORPORATE_BILLING_INFO_VIEW,
        },
        {
          title: <FormattedMessage {...messages.corporateBillingInfoEdit} />,
          key: Permission.CORPORATE_BILLING_INFO_EDIT,
        },
        {
          title: <FormattedMessage {...messages.corporateFeeRatesView} />,
          key: Permission.CORPORATE_FEE_RATES_VIEW,
        },
        {
          title: <FormattedMessage {...messages.corporateFeeRatesEdit} />,
          key: Permission.CORPORATE_FEE_RATES_EDIT,
        },
        {
          title: <FormattedMessage {...messages.corporateProcessorConfigView} />,
          key: Permission.CORPORATE_PROCESSOR_CONFIGURATION_VIEW,
        },
        {
          title: <FormattedMessage {...messages.corporateProcessorConfigEdit} />,
          key: Permission.CORPORATE_PROCESSOR_CONFIGURATION_EDIT,
        },
        {
          title: <FormattedMessage {...messages.corporateTaxesInfoView} />,
          key: Permission.CORPORATE_TAXES_INFO_VIEW,
        },
        {
          title: <FormattedMessage {...messages.corporateTaxesInfoEdit} />,
          key: Permission.CORPORATE_TAXES_INFO_EDIT,
        },
        {
          title: <FormattedMessage {...messages.corporateIntegrationView} />,
          key: Permission.CORPORATE_INTEGRATION_VIEW,
        },
        {
          title: <FormattedMessage {...messages.corporateIntegrationEdit} />,
          key: Permission.CORPORATE_INTEGRATION_EDIT,
        },
        {
          title: <FormattedMessage {...messages.corporateIntegrationChangeStatus} />,
          key: Permission.CORPORATE_INTEGRATION_CHANGE_STATUS,
        },
        {
          title: <FormattedMessage {...messages.corporateOtherInfoView} />,
          key: Permission.CORPORATE_OTHER_INFO_VIEW,
        },
        {
          title: <FormattedMessage {...messages.corporateOtherInfoEdit} />,
          key: Permission.CORPORATE_OTHER_INFO_EDIT,
        },
        {
          title: <FormattedMessage {...messages.corporateRequiredFieldsView} />,
          key: Permission.CORPORATE_REQUIRED_FIELDS_VIEW,
        },
        {
          title: <FormattedMessage {...messages.corporateRequiredFieldsEdit} />,
          key: Permission.CORPORATE_REQUIRED_FIELDS_EDIT,
        },
        {
          title: <FormattedMessage {...messages.corporatePayPeriodSettingsView} />,
          key: Permission.CORPORATE_PAY_PERIOD_SETTINGS_VIEW,
        },
        {
          title: <FormattedMessage {...messages.corporatePayPeriodSettingsCreate} />,
          key: Permission.CORPORATE_PAY_PERIOD_SETTINGS_CREATE,
        },
        {
          title: <FormattedMessage {...messages.corporatePayPeriodSettingsEdit} />,
          key: Permission.CORPORATE_PAY_PERIOD_SETTINGS_EDIT,
        },
        {
          title: <FormattedMessage {...messages.corporatePayPeriodView} />,
          key: Permission.CORPORATE_PAY_PERIOD_VIEW,
        },
        {
          title: <FormattedMessage {...messages.corporatePayPeriodEdit} />,
          key: Permission.CORPORATE_PAY_PERIOD_EDIT,
        },
        {
          title: <FormattedMessage {...messages.corporatePayPeriodChangeStatus} />,
          key: Permission.CORPORATE_PAY_PERIOD_CHANGE_STATUS,
        },
        {
          title: <FormattedMessage {...messages.corporateServicesView} />,
          key: Permission.CORPORATE_SERVICES_VIEW,
        },
        {
          title: <FormattedMessage {...messages.corporateServicesEdit} />,
          key: Permission.CORPORATE_SERVICES_EDIT,
        },
      ],
    },
  ],
  [PermissionGroupsCorporateLevel.SERVICE_MANAGEMENT]: [
    {
      title: PermissionsGroupsLabels[PermissionGroupsCorporateLevel.SERVICE_MANAGEMENT],
      key: PermissionGroupsCorporateLevel.SERVICE_MANAGEMENT,
      children: [
        {
          title: <FormattedMessage {...messages.corporateServiceView} />,
          key: Permission.SERVICE_VIEW,
        },
        {
          title: <FormattedMessage {...messages.corporateServiceCreate} />,
          key: Permission.SERVICE_CREATE,
        },
        {
          title: <FormattedMessage {...messages.corporateServiceEdit} />,
          key: Permission.SERVICE_EDIT,
        },
        {
          title: <FormattedMessage {...messages.corporateServiceChangeStatus} />,
          key: Permission.SERVICE_CHANGE_STATUS,
        },
        {
          title: <FormattedMessage {...messages.corporateFeeView} />,
          key: Permission.FEE_VIEW,
        },
        {
          title: <FormattedMessage {...messages.corporateFeeCreate} />,
          key: Permission.FEE_CREATE,
        },
        {
          title: <FormattedMessage {...messages.corporateFeeEdit} />,
          key: Permission.FEE_EDIT,
        },
        {
          title: <FormattedMessage {...messages.corporateFeeChangeStatus} />,
          key: Permission.FEE_CHANGE_STATUS,
        },
        {
          title: <FormattedMessage {...messages.corporateServiceBundleView} />,
          key: Permission.SERVICE_BUNDLE_VIEW,
        },
        {
          title: <FormattedMessage {...messages.corporateServiceBundleCreate} />,
          key: Permission.SERVICE_BUNDLE_CREATE,
        },
        {
          title: <FormattedMessage {...messages.corporateServiceBundleEdit} />,
          key: Permission.SERVICE_BUNDLE_EDIT,
        },
        {
          title: <FormattedMessage {...messages.corporateServiceBundleChangeStatus} />,
          key: Permission.SERVICE_BUNDLE_CHANGE_STATUS,
        },
        {
          title: <FormattedMessage {...messages.corporateServiceBundleDuplicate} />,
          key: Permission.SERVICE_BUNDLE_DUPLICATE,
        },
        {
          title: <FormattedMessage {...messages.corporateContractView} />,
          key: Permission.CONTRACT_VIEW,
        },
        {
          title: <FormattedMessage {...messages.corporateContractCreate} />,
          key: Permission.CONTRACT_CREATE,
        },
        {
          title: <FormattedMessage {...messages.corporateContractEdit} />,
          key: Permission.CONTRACT_EDIT,
        },
        {
          title: <FormattedMessage {...messages.corporateContractChangeStatus} />,
          key: Permission.CONTRACT_CHANGE_STATUS,
        },
        {
          title: <FormattedMessage {...messages.corporateWaiverView} />,
          key: Permission.WAIVER_VIEW,
        },
        {
          title: <FormattedMessage {...messages.corporateWaiverCreate} />,
          key: Permission.WAIVER_CREATE,
        },
        {
          title: <FormattedMessage {...messages.corporateWaiverEdit} />,
          key: Permission.WAIVER_EDIT,
        },
        {
          title: <FormattedMessage {...messages.corporateWaiverChangeStatus} />,
          key: Permission.WAIVER_CHANGE_STATUS,
        },
      ],
    },
  ],
  [PermissionGroupsCorporateLevel.DICTIONARIES]: [
    {
      title: PermissionsGroupsLabels[PermissionGroupsCorporateLevel.DICTIONARIES],
      key: PermissionGroupsCorporateLevel.DICTIONARIES,
      children: [
        {
          title: <FormattedMessage {...messages.corporateDictionariesView} />,
          key: Permission.DICTIONARIES_VIEW,
        },
        {
          title: <FormattedMessage {...messages.corporateDictionariesCreate} />,
          key: Permission.DICTIONARIES_CREATE,
        },
        {
          title: <FormattedMessage {...messages.corporateDictionariesEdit} />,
          key: Permission.DICTIONARIES_EDIT,
        },
        {
          title: <FormattedMessage {...messages.corporateDictionariesChangeStatus} />,
          key: Permission.DICTIONARIES_CHANGE_STATUS,
        },
        {
          title: <FormattedMessage {...messages.corporateCameFromIndicationView} />,
          key: Permission.CAME_FROM_INDICATION_VIEW,
        },
        {
          title: <FormattedMessage {...messages.corporateCameFromIndicationCreate} />,
          key: Permission.CAME_FROM_INDICATION_CREATE,
        },
        {
          title: <FormattedMessage {...messages.corporateCameFromIndicationEdit} />,
          key: Permission.CAME_FROM_INDICATION_EDIT,
        },
        {
          title: <FormattedMessage {...messages.corporateCameFromIndicationChangeStatus} />,
          key: Permission.CAME_FROM_INDICATION_CHANGE_STATUS,
        },
        {
          title: <FormattedMessage {...messages.corporateAdditionalGuestFieldView} />,
          key: Permission.ADDITIONAL_GUEST_FIELD_VIEW,
        },
        {
          title: <FormattedMessage {...messages.corporateAdditionalGuestFieldCreate} />,
          key: Permission.ADDITIONAL_GUEST_FIELD_CREATE,
        },
        {
          title: <FormattedMessage {...messages.corporateAdditionalGuestFieldEdit} />,
          key: Permission.ADDITIONAL_GUEST_FIELD_EDIT,
        },
        {
          title: <FormattedMessage {...messages.corporateAdditionalGuestFieldChangeStatus} />,
          key: Permission.ADDITIONAL_GUEST_FIELD_CHANGE_STATUS,
        },
        {
          title: <FormattedMessage {...messages.corporateAlertSoundView} />,
          key: Permission.ALERT_SOUND_VIEW,
        },
        {
          title: <FormattedMessage {...messages.corporateAlertSoundEdit} />,
          key: Permission.ALERT_SOUND_EDIT,
        },
        {
          title: <FormattedMessage {...messages.corporateNoteCodeView} />,
          key: Permission.NOTE_CODE_VIEW,
        },
        {
          title: <FormattedMessage {...messages.corporateNoteCodeCreate} />,
          key: Permission.NOTE_CODE_CREATE,
        },
        {
          title: <FormattedMessage {...messages.corporateNoteCodeEdit} />,
          key: Permission.NOTE_CODE_EDIT,
        },
        {
          title: <FormattedMessage {...messages.corporateNoteCodeChangeStatus} />,
          key: Permission.NOTE_CODE_CHANGE_STATUS,
        },
        {
          title: <FormattedMessage {...messages.corporateFallthroughReasonView} />,
          key: Permission.FALLTHROUGH_REASON_VIEW,
        },
        {
          title: <FormattedMessage {...messages.corporateFallthroughReasonCreate} />,
          key: Permission.FALLTHROUGH_REASON_CREATE,
        },
        {
          title: <FormattedMessage {...messages.corporateFallthroughReasonEdit} />,
          key: Permission.FALLTHROUGH_REASON_EDIT,
        },
        {
          title: <FormattedMessage {...messages.corporateFallthroughReasonChangeStatus} />,
          key: Permission.FALLTHROUGH_REASON_CHANGE_STATUS,
        },
        {
          title: <FormattedMessage {...messages.corporateDepartmentView} />,
          key: Permission.DEPARTMENT_VIEW,
        },
        {
          title: <FormattedMessage {...messages.corporateDepartmentCreate} />,
          key: Permission.DEPARTMENT_CREATE,
        },
        {
          title: <FormattedMessage {...messages.corporateDepartmentEdit} />,
          key: Permission.DEPARTMENT_EDIT,
        },
        {
          title: <FormattedMessage {...messages.corporateDepartmentChangeStatus} />,
          key: Permission.DEPARTMENT_CHANGE_STATUS,
        },
        {
          title: <FormattedMessage {...messages.corporateClubGroupView} />,
          key: Permission.CLIENT_GROUP_VIEW,
        },
        {
          title: <FormattedMessage {...messages.corporateClubGroupCreate} />,
          key: Permission.CLIENT_GROUP_CREATE,
        },
        {
          title: <FormattedMessage {...messages.corporateClubGroupEdit} />,
          key: Permission.CLIENT_GROUP_EDIT,
        },
        {
          title: <FormattedMessage {...messages.corporateClubGroupChangeStatus} />,
          key: Permission.CLIENT_GROUP_CHANGE_STATUS,
        },
        {
          title: <FormattedMessage {...messages.corporateInsuranceCompanyView} />,
          key: Permission.INSURANCE_COMPANY_VIEW,
        },
        {
          title: <FormattedMessage {...messages.corporateInsuranceCompanyCreate} />,
          key: Permission.INSURANCE_COMPANY_CREATE,
        },
        {
          title: <FormattedMessage {...messages.corporateInsuranceCompanyEdit} />,
          key: Permission.INSURANCE_COMPANY_EDIT,
        },
        {
          title: <FormattedMessage {...messages.corporateInsuranceCompanyChangeStatus} />,
          key: Permission.INSURANCE_COMPANY_CHANGE_STATUS,
        },
        {
          title: <FormattedMessage {...messages.corporateAccessHourView} />,
          key: Permission.ACCESS_HOUR_VIEW,
        },
        {
          title: <FormattedMessage {...messages.corporateAccessHourCreate} />,
          key: Permission.ACCESS_HOUR_CREATE,
        },
        {
          title: <FormattedMessage {...messages.corporateAccessHourEdit} />,
          key: Permission.ACCESS_HOUR_EDIT,
        },
        {
          title: <FormattedMessage {...messages.corporateAccessHourChangeStatus} />,
          key: Permission.ACCESS_HOUR_CHANGE_STATUS,
        },
        {
          title: <FormattedMessage {...messages.corporateEventTagView} />,
          key: Permission.EVENT_TAG_VIEW,
        },
        {
          title: <FormattedMessage {...messages.corporateEventTagCreate} />,
          key: Permission.EVENT_TAG_CREATE,
        },
        {
          title: <FormattedMessage {...messages.corporateEventTagEdit} />,
          key: Permission.EVENT_TAG_EDIT,
        },
        {
          title: <FormattedMessage {...messages.corporateEventTagChangeStatus} />,
          key: Permission.EVENT_TAG_CHANGE_STATUS,
        },
        {
          title: <FormattedMessage {...messages.corporateResourceTagView} />,
          key: Permission.RESOURCE_TAG_VIEW,
        },
        {
          title: <FormattedMessage {...messages.corporateResourceTagCreate} />,
          key: Permission.RESOURCE_TAG_CREATE,
        },
        {
          title: <FormattedMessage {...messages.corporateResourceTagEdit} />,
          key: Permission.RESOURCE_TAG_EDIT,
        },
        {
          title: <FormattedMessage {...messages.corporateResourceTagChangeStatus} />,
          key: Permission.RESOURCE_TAG_CHANGE_STATUS,
        },
        {
          title: <FormattedMessage {...messages.corporateNotificationView} />,
          key: Permission.NOTIFICATION_VIEW,
        },
        {
          title: <FormattedMessage {...messages.corporateNotificationEdit} />,
          key: Permission.NOTIFICATION_EDIT,
        },
        {
          title: <FormattedMessage {...messages.corporateHelpInformationView} />,
          key: Permission.HELP_INFORMATION_VIEW,
        },
        {
          title: <FormattedMessage {...messages.corporateHelpInformationCreate} />,
          key: Permission.HELP_INFORMATION_CREATE,
        },
        {
          title: <FormattedMessage {...messages.corporateHelpInformationEdit} />,
          key: Permission.HELP_INFORMATION_EDIT,
        },
        {
          title: <FormattedMessage {...messages.corporateHelpInformationChangeStatus} />,
          key: Permission.HELP_INFORMATION_CHANGE_STATUS,
        },
        {
          title: <FormattedMessage {...messages.corporateEndReasonView} />,
          key: Permission.END_REASON_VIEW,
        },
        {
          title: <FormattedMessage {...messages.corporateEndReasonCreate} />,
          key: Permission.END_REASON_CREATE,
        },
        {
          title: <FormattedMessage {...messages.corporateEndReasonEdit} />,
          key: Permission.END_REASON_EDIT,
        },
        {
          title: <FormattedMessage {...messages.corporateEndReasonChangeStatus} />,
          key: Permission.END_REASON_CHANGE_STATUS,
        },
      ],
    },
  ],
  [PermissionGroupsCorporateLevel.COMMUNICATION]: [
    {
      title: PermissionsGroupsLabels[PermissionGroupsCorporateLevel.COMMUNICATION],
      key: PermissionGroupsCorporateLevel.COMMUNICATION,
      children: [
        {
          title: <FormattedMessage {...messages.bannerAdvertisementView} />,
          key: Permission.BANNER_ADVERTISEMENT_VIEW,
        },
        {
          title: <FormattedMessage {...messages.bannerAdvertisementCreate} />,
          key: Permission.BANNER_ADVERTISEMENT_CREATE,
        },
        {
          title: <FormattedMessage {...messages.bannerAdvertisementEdit} />,
          key: Permission.BANNER_ADVERTISEMENT_EDIT,
        },
        {
          title: <FormattedMessage {...messages.bannerAdvertisementChangeStatus} />,
          key: Permission.BANNER_ADVERTISEMENT_CHANGE_STATUS,
        },
        {
          title: <FormattedMessage {...messages.pushNotificationView} />,
          key: Permission.PUSH_NOTIFICATION_VIEW,
        },
        {
          title: <FormattedMessage {...messages.pushNotificationCreate} />,
          key: Permission.PUSH_NOTIFICATION_CREATE,
        },
        {
          title: <FormattedMessage {...messages.pushNotificationEdit} />,
          key: Permission.PUSH_NOTIFICATION_EDIT,
        },
        {
          title: <FormattedMessage {...messages.pushNotificationChangeStatus} />,
          key: Permission.PUSH_NOTIFICATION_CHANGE_STATUS,
        },
      ],
    },
  ],
  ...PermissionsArrayCorporateOrClubLevel,
};

export const PermissionsArrayClubLevel: IPermissionsArray<PermissionGroupsClubLevel &
  PermissionGroupsCorporateOrClubLevel> = {
  [PermissionGroupsClubLevel.FINANCIAL]: [
    {
      title: PermissionsGroupsLabels[PermissionGroupsClubLevel.FINANCIAL],
      key: PermissionGroupsClubLevel.FINANCIAL,
      children: [
        {
          title: <FormattedMessage {...messages.setClientFeeSchedule} />,
          key: Permission.SET_CLIENT_FEE_SCHEDULE,
        },
      ],
    },
  ],
  [PermissionGroupsClubLevel.POINT_OF_SALE_POS]: [
    {
      title: PermissionsGroupsLabels[PermissionGroupsClubLevel.POINT_OF_SALE_POS],
      key: PermissionGroupsClubLevel.POINT_OF_SALE_POS,
      children: [
        {
          title: <FormattedMessage {...messages.openRegister} />,
          key: Permission.OPEN_REGISTER,
        },
        {
          title: <FormattedMessage {...messages.closeRegister} />,
          key: Permission.CLOSE_REGISTER,
        },
        {
          title: <FormattedMessage {...messages.giveDiscount} />,
          key: Permission.GIVE_DISCOUNT,
        },
        {
          title: <FormattedMessage {...messages.voidInvoice} />,
          key: Permission.VOID_INVOICE,
        },
        {
          title: <FormattedMessage {...messages.modifySalesperson} />,
          key: Permission.MODIFY_SALESPERSON,
        },
      ],
    },
  ],
  [PermissionGroupsClubLevel.COLLECTIONS]: [
    {
      title: PermissionsGroupsLabels[PermissionGroupsClubLevel.COLLECTIONS],
      key: PermissionGroupsClubLevel.COLLECTIONS,
      children: [
        {
          title: <FormattedMessage {...messages.sendLetter} />,
          key: Permission.SEND_A_LETTER,
        },
      ],
    },
  ],
  ...PermissionsArrayCorporateOrClubLevel,
};

export const permissionsArray = {
  [PermissionLevels.PEAK]: PermissionsArrayPeakLevel,
  [PermissionLevels.CLIENT]: PermissionsArrayClubLevel,
  [PermissionLevels.CORPORATE]: PermissionsArrayCorporateLevel,
};
